export default __webpack_public_path__ + "static/media/margo.d53220d1.jpg";